import React, { Component } from 'react';

export default class Ecosystem extends Component{
  render(){
    return(
      <div className="row section">
        <div className="col-sm-12">
          <div className="section panel">
            <h2>Ecosyst&egrave;me informatique de l’USI-MENFP</h2>

            <p>
              L’ensemble dynamique des programmes d&eacute;velopp&eacute;s, en d&eacute;veloppement ou &agrave; l’&eacute;tude au niveau de l’USI permettent  d'aller &agrave; la rencontre des diff&eacute;rentes structures du MENFP au sein de leur <span data-toggle="tooltip" className="usi_tooltip" title="Bien choisir son &eacute;cosyst&egrave;me informatique c'est renforcer votre libert&eacute; et celles de tous les autres.">environnement</span> , qu'il s'agisse des utilisateurs, des op&eacute;rateurs ou des fournisseurs de services. L’essentiel est de tirer le meilleur parti de ce nouveau monde de connexions afin de r&eacute;duire les coûts d'exploitation, faciliter la d&eacute;mat&eacute;rialisation des processus, gagner en efficacit&eacute; et r&eacute;pondre plus rapidement aux diff&eacute;rents besoins. Dans la quête de l'automatisation quasi compl&egrave;te des processus m&eacute;tier, cet espace repr&eacute;sente une gigantesque r&eacute;serve d'actifs informationnels destin&eacute;s &agrave; r&eacute;pondre &agrave; des besoins sp&eacute;cifiques. En voici une liste non exhaustive :
            </p>

            <ul>
              <li>Le syst&egrave;me d’information des Ressources Humaines : SIGERH (Gestion du personnel Administratif et des Enseignants du secteur public).</li>
              <li>Le syst&egrave;me d’information des &eacute;coles, des enseignants et des &eacute;l&egrave;ves : SIGEEE.</li>
              <li>Le Syst&egrave;me de gestion de la passation de march&eacute; : SYSGEP.</li>
              <li>Le Syst&egrave;me de gestion des Ecoles du PSUGO : SYSGEEPSUGO.</li>
              <li>Le Syst&egrave;me de gestion des &eacute;coles du Programme pour une &eacute;ducation de Qualit&eacute; en Haïti : SYSGEEPEQH.</li>
              <li>Le Syst&egrave;me d’Information de Gestion des Archives : SIGEDA.</li>
              <li>Le Syst&egrave;me d’Information de Gestion de la Flotte des V&eacute;hicules : SIGEFV.</li>
              <li>Le Syst&egrave;me d’Information de Gestion des Stocks et approvisionnement : SIGESA.</li>
              <li>Le Syst&egrave;me d’Information de Gestion et d’&eacute;valuation du mat&eacute;riel didactique : SIGEEMAD</li>
            </ul>

          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Ecosystem.js